import { combineReducers } from 'redux';

import { WorkspaceStatus } from '@neptune/pricing-workspace-status-domain';
import {
  FETCH_STATUS_FAILED,
  FETCH_STATUS_NONE,
  FETCH_STATUS_PENDING,
  FETCH_STATUS_SUCCESS,
  FetchStatus,
} from '@neptune/shared/common-domain';

import { WorkspaceStatusActions, WorkspaceStatusActionTypes } from './actions';

export type SingleWorkspaceStatusState = {
  fetchStatus: FetchStatus;
  date?: string;
} & Partial<WorkspaceStatus>;

type ByOrganizationState = Record<string, SingleWorkspaceStatusState | undefined>;

export type WorkspaceStatusState = {
  byOrganization: ByOrganizationState;
};

const byOrganizationSupportedActionTypes = Object.values(WorkspaceStatusActionTypes);

export const workspaceStatusReducer = combineReducers({
  byOrganization: byOrganizationReducer,
});

function byOrganizationReducer(
  state: ByOrganizationState = {},
  action: WorkspaceStatusActions,
): ByOrganizationState {
  if (!byOrganizationSupportedActionTypes.includes(action.type)) {
    return state;
  }

  const organizationIdentifier = action.payload.organizationIdentifier;
  const currentState = state[organizationIdentifier];
  const newState = singleWorkspaceStateReducer(currentState, action);

  return currentState === newState
    ? state
    : {
        ...state,
        [organizationIdentifier]: newState,
      };
}

const singleWorkspaceStateInitialState: SingleWorkspaceStatusState = {
  fetchStatus: FETCH_STATUS_NONE,
};

function singleWorkspaceStateReducer(
  state: SingleWorkspaceStatusState = singleWorkspaceStateInitialState,
  action: WorkspaceStatusActions,
): SingleWorkspaceStatusState {
  switch (action.type) {
    case WorkspaceStatusActionTypes.request: {
      return state.fetchStatus === FETCH_STATUS_PENDING
        ? state
        : {
            ...state,
            fetchStatus: FETCH_STATUS_PENDING,
          };
    }

    case WorkspaceStatusActionTypes.success: {
      return {
        ...action.payload.status,
        fetchStatus: FETCH_STATUS_SUCCESS,
        date: action.payload.date,
      };
    }

    case WorkspaceStatusActionTypes.fail: {
      return state.fetchStatus === FETCH_STATUS_FAILED
        ? state
        : {
            ...state,
            fetchStatus: FETCH_STATUS_FAILED,
          };
    }

    default: {
      return state;
    }
  }
}
